import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bank-account-setting',
  templateUrl: './bank-account-setting.component.html',
  styleUrls: ['./bank-account-setting.component.css']
})
export class BankAccountSettingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
